import './CasPanel.scss';

import { Card } from '@mui/material';

interface ICasPanel {
  children: React.ReactNode;
  color?: 'primary'| 'danger';
}

export default function CasPanel({ color, children }: ICasPanel) {
  const bgColor = {
    primary: '#ecffec',  // light green color
    danger: '#fff2f4'  // light red color
  };

  return (
    <Card sx={{ backgroundColor: color ? bgColor[color] : undefined }} className="CasPanel">
      {children}
    </Card>
  );
}
